import styled from 'styled-components';

export const InfoPageBoldText = styled.span`
  font-weight: 700;
`;
